exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-warning[data-v-25def62a] {\n  color: #fff;\n  background-color: #b2c740;\n  border-color: #a3b836;\n}\n", ""]);

// exports
